import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ProcessOperationImplementationState } from "./model";

let state: ProcessOperationImplementationState = {
  processOperationImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ProcessOperationImplementationState, RootStateType>;
